module.exports = __webpack_public_path__ + "static/media/cowbell.470b5edb.wav";